import React from "react";
import "./vignetteBtn.css";
import { useLocation, useNavigate } from "react-router-dom";
const VignetteBtn = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const previousPage = "/reimagine-health/2030_rural_india";
  const activeBTn = `active-vignettes-btn btn`;
  const inActiveBTn = `inactive-vignettes-btn btn`;
  return (
    <div className="d-flex   pb-3 justify-content-between   pt-3">
      <button
        className={pathname === previousPage ? inActiveBTn : activeBTn}
        onClick={() => navigate(previousPage)}
      >
        Previous 
      </button>

      <button
        className={pathname !== previousPage ? inActiveBTn : activeBTn}
        onClick={() => navigate("/reimagine-health/2030_frontline_health")}
      >
        Next 
      </button>
    </div>
  );
};

export default VignetteBtn;
